import {USER_ATTRIBUTE_UNAVAILABLE} from './user-attributes';

/**
 * Checks user's IDS id whether it's SBN-related
 * @param scimUserId IDS user id.
 * @returns Boolean value whether user has AN... IDS id
 */
export function checkSBNUser(scimUserId: string): boolean {
  return scimUserId.startsWith('AN');
}

/**
 * Returns IDSid depending on type of user
 * @param scimUserId IDS user id.
 * @returns String with scimUserId or placeholder for SBN user
 */
export function getIDSid(scimUserId: string): string {
  return checkSBNUser(scimUserId) ? USER_ATTRIBUTE_UNAVAILABLE : scimUserId;
}
